import { getActivePinia } from 'pinia';
import { useActionBarCrossSellAnalyticsStore } from '~/stores/actionBarCrossSellAnalyticsStore/actionBarCrossSellAnalyticsStore';
import type { ActionBarCrossSellAttribution } from './types';

export function getActionBarCrossSellAttributionForSku(
  sku: string
): ActionBarCrossSellAttribution | undefined {
  if (!getActivePinia()) {
    return undefined;
  }

  return useActionBarCrossSellAnalyticsStore().getAttribution(sku);
}

export function hasActionBarCrossSellAttributionForSkus(
  skus: string[]
): boolean {
  if (!getActivePinia()) {
    return false;
  }

  return useActionBarCrossSellAnalyticsStore().hasAttributionInCart(skus);
}
